<article class="login-page">
  <section class="university-name-container">
    <figure>
      <img src="images/aum-logo.png" alt="aum Logo" />
    </figure>
    <p>{{ "universityName" | translate }}</p>
  </section>
  <div class="main-form">
    <section class="login-form-container">
      <div class="form-intro">
        <p class="login-intro">{{ "login.intro.login" | translate }}</p>
        <p class="login-p">{{ "login.intro.p" | translate }}</p>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
        <app-text-input
          [textControl]="this.loginForm.controls['credentials']"
          [config]="{
            placeholder: 'login.form.credentials' | translate,
            minLength: 1,
            maxLength: 50,
            icon: 'username',
            preventSpace: true,
            'margin-block-end': '1em'
          }"
        ></app-text-input>
        <app-password-input
          placeholder="login.form.password"
          [passwordControl]="this.loginForm.controls['password']"
        ></app-password-input>

        <div class="remember-forget">
          <div class="forget">
            <a
              routerLink="/auth/forget-password"
              ariaCurrentWhenActive="page"
              >{{ "login.form.forgetPassword" | translate }}</a
            >
          </div>
        </div>
        <app-form-button
          [config]="{
            text: 'login.form.button' | translate,
            form: this.loginForm,
            type: 'submit',
          }"
        ></app-form-button>
        <div class="first-time-login">
          <a routerLink="/auth/first-time-login" ariaCurrentWhenActive="page">{{
            "login.form.firstTimeLogin" | translate
          }}</a>
        </div>
      </form>
      <footer>
        Copyright &copy; 2023-{{ this.currentYear }} by
        <a target="_blank" href="https://code-mint.com/">CodeMint</a>
      </footer>
    </section>
  </div>
</article>
<figure class="login-top-right-shape">
  <img src="svgs/login/login-top-right-shape.svg" alt="" />
</figure>
<figure class="login-bottom-left-shape">
  <img src="svgs/login/login-bottom-left-shape.svg" alt="" />
</figure>
<section class="logo-container">
  <figure>
    <img src="svgs/app/full-eduminty-logo.svg" alt="EduMinty logo" />
  </figure>
</section>
